import create from 'zustand';

const APP_INITIAL = {
	title: '',
	section: '',
	navigation: false,
	authenticated: false,
	valid: false,
	update: false,

	messenger: false,
	unread: false,
	socket: null,

	theme: 'light',

	user: {
		id: 0,
		role: '',
		status: '',
		avatar: '',
		fullName: ''
	}
};

export const useAppStore = create(set => ({
	...APP_INITIAL,

	// Handle title change
	setTitle: (title) => set({
		title
	}),

	// Handle section change
	setSection: (section) => set({
		section
	}),

	// Handle navigation toggle
	setNavigation: (navigation) => set({
		navigation
	}),
	
	// Handle authentication state
	setAuthenticated: (authenticated) => set({
		authenticated
	}),

	// Handle valid user state
	setValid: (valid) => set({
		valid
	}),

	// Handle update app state
	setUpdate: (update) => set({
		update
	}),

	// Handle messenger state
	setMessenger: () => set(state => ({
		messenger: !state.messenger
	})),

	// Handle socket change
	setSocket: (socket) => set({
		socket
	}),

	// Handle theme change
	setTheme: (theme) => set({
		theme
	}),

	// Handle user data
	setUser: (user) => set(state => ({
		user: {
			...state.user,
			id: user.id,
			role: user.role,
			status: user.status,
			avatar: user.avatar,
			fullName: user.fullName
		}
	})),

	// Reset app's state
	onReset: () => set({
		...APP_INITIAL
	})
}));